var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "w-full pb-10" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { hasData: !!_vm.company, loading: _vm.$apollo.loading } },
        [
          _c("PageHeadContainer", {
            attrs: { title: _vm.companyName },
            scopedSlots: _vm._u([
              {
                key: "avatar",
                fn: function () {
                  return [
                    _c("PageHeadAvatar", {
                      attrs: {
                        s3FileKey: _vm.company.company_logo,
                        initial: _vm.initials,
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "icons",
                fn: function () {
                  return [
                    _vm.notificationsDisabled
                      ? _c("NotificationOffIcon", {
                          staticClass: "w-6 h-6 text-gray-800",
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "actions",
                fn: function () {
                  return [
                    _c("CompanyNotificationsButton", {
                      staticClass: "ml-auto",
                      attrs: {
                        buttonVariant: "secondary",
                        companyId: _vm.company.id,
                        currentUserId: _vm.currentUser.id,
                      },
                      model: {
                        value: _vm.notificationsDisabled,
                        callback: function ($$v) {
                          _vm.notificationsDisabled = $$v
                        },
                        expression: "notificationsDisabled",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("InformationWrapper", {
            scopedSlots: _vm._u([
              {
                key: "primary",
                fn: function () {
                  return [
                    _vm.showDescriptionPlaceholder
                      ? _c(
                          "InformationCard",
                          { attrs: { title: "Description" } },
                          [_vm._v(" " + _vm._s(_vm.companyDescription) + " ")]
                        )
                      : _c(
                          "InformationCard",
                          { attrs: { title: "Description" } },
                          [_vm._v(" " + _vm._s(_vm.companyDescription) + " ")]
                        ),
                  ]
                },
                proxy: true,
              },
              {
                key: "secondary",
                fn: function () {
                  return [
                    _c(
                      "InformationCard",
                      {
                        staticClass: "xxlLabelContainer",
                        attrs: { title: "Location:" },
                      },
                      [
                        _c("CardBodyItem", {
                          attrs: {
                            label: "Country",
                            content: _vm.company.country,
                          },
                        }),
                        _c("CardBodyItem", {
                          attrs: {
                            label: _vm.stateProvinceLabel,
                            content: _vm.company.state,
                          },
                        }),
                        _c("CardBodyItem", {
                          attrs: { label: "City", content: _vm.company.city },
                        }),
                        _c("CardBodyItem", {
                          attrs: {
                            label: "Street Address",
                            content: _vm.companyAddress,
                          },
                        }),
                      ],
                      1
                    ),
                    !!_vm.phoneNumber
                      ? _c("InformationCard", {
                          attrs: {
                            title: "Phone Number",
                            content: _vm.phoneNumber,
                          },
                        })
                      : _vm._e(),
                    !!_vm.numberOfEmployees
                      ? _c("InformationCard", {
                          attrs: {
                            title: "Employees",
                            content: _vm.numberOfEmployees,
                          },
                        })
                      : _vm._e(),
                    !!_vm.website
                      ? _c("InformationCard", { attrs: { title: "Website" } }, [
                          _c(
                            "a",
                            {
                              staticClass: "cursor-pointer text-primary-500",
                              attrs: { target: "_blank", href: _vm.website },
                            },
                            [_vm._v(" " + _vm._s(_vm.website) + " ")]
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          !!_vm.postings.length
            ? _c(
                "div",
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "text-lg leading-6 text-gray-800 border-b mb-4",
                    },
                    [_vm._v("Current Job Postings")]
                  ),
                  _vm._l(_vm.postings, function (posting) {
                    return _c("PostingCard", {
                      key: posting.id,
                      attrs: {
                        posting: posting,
                        currentUserId: _vm.currentUser.id,
                        isMarketplace: "",
                      },
                    })
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }